<template>
  <v-app :style="{ background: $vuetify.theme.themes.light.background }">
    <v-container grid-list-xl text-xs-center>
        <v-layout :class="!$vuetify.breakpoint.mdAndUp ? '' : 'row wrap'">
          <v-flex :class="!$vuetify.breakpoint.mdAndUp ? '' : 'xs4 offset-xs4'">
            <v-form>
              <validation-observer ref="observer" v-slot="observerProps">
              <v-card class="white">
                <v-img
                    height="200px"
                    :src="$vuetify.breakpoint.xsOnly
                            ? cdnUrl + '/assets/images/sell/offer/unauthenticated/main_ph_sp.png'
                            : cdnUrl + '/assets/images/sell/offer/unauthenticated/main_ph.png'"
                />
                <v-card-title v-if="isCharibon">お申込み状況確認ログイン</v-card-title>
                <v-card-title v-else>買取状況確認ログイン</v-card-title>
                <v-card-text>
                  <validation-provider v-slot="{ errors }"
                                       name="メールアドレス"
                                       rules="required|email_character"
                                       ref="email">
                    <v-text-field
                        clearable
                        name="email"
                        :value="formItems.email"
                        @input="updateFormItems({name:'email', value: removalZeroWidthSpace($event)})"
                        label="メールアドレス"
                        type="email"
                        :error-messages="errors"
                        required
                    >
                    </v-text-field>
                  </validation-provider>
                  <validation-provider v-slot="{ errors }" name="買取ナンバー" rules="required|max:12|min:12|alpha_num" ref="buyNumber">
                    <v-text-field
                        clearable
                        name="buyNumber"
                        :value="formItems.buyNumber"
                        @input="updateFormItems({name:'buyNumber', value: removalZeroWidthSpace($event)})"
                        @blur="updateFormItems({name:'buyNumber', value: spaceRemoval($event.target.value)})"
                        label="買取ナンバー"
                        type="text"
                        counter="12"
                        :error-messages="errors"
                        required
                    >
                    </v-text-field>
                  </validation-provider>
                </v-card-text>
                <v-card-actions>
                  <v-btn
                    class="d-flex white--text ml-auto text-subtitle-1 rounded-lg pr-2"
                    color="#EF0B68"
                    max-width="80"
                    width="100%"
                    height="48"
                    @click="buyDataAuth"
                    :disabled="observerProps.invalid">
                    確認
                  </v-btn>
                </v-card-actions>
              </v-card>
              </validation-observer>
            </v-form>
          </v-flex>
        </v-layout>
    </v-container>
    <v-dialog v-model="dialogNoOffer" max-width="440" :width="$vuetify.breakpoint.smAndDown? '100%': '440px'">
      <v-card>
        <v-card-title class="text-body-1 text-sm-h6 py-4 justify-center">
          該当のデータが存在しません。
        </v-card-title>

        <v-card-text class="py-4">
          メールを確認頂き、再度入力をしてください。
        </v-card-text>

        <v-card-actions class="py-4">
          <v-spacer></v-spacer>
          <v-btn @click="dialogNoOffer = false">閉じる</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogExpiredOffer" max-width="600" :width="$vuetify.breakpoint.smAndDown? '100%': 'auto'">
      <v-card>
        <v-card-title class="text-body-1 text-sm-h6 py-4 justify-center">
          取引が完了しています。
        </v-card-title>
        <v-card-text class="pb-4">
          <p>取引完了から3ヵ月経過すると、このページからアクセスできません。</p>
          <p class="mb-0">以下よりお問い合わせください。</p>
          <p class="mb-0"><router-link :to="{ name: 'InquiryForm'}">お問い合わせ</router-link></p>
        </v-card-text>
        <v-card-actions class="py-4">
          <v-spacer></v-spacer>
          <v-btn @click="dialogExpiredOffer = false">閉じる</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogFatalError" max-width="440" :width="$vuetify.breakpoint.smAndDown? '100%': '440px'">
      <v-card>
        <v-card-title class="text-body-1 text-sm-h6 py-4 justify-center">
          エラーが発生しました
        </v-card-title>

        <v-card-text class="py-4">
          <p class="mb-0">エラーを検出したため、実行することができませんでした。</p>
          <p class="mb-0">しばらく時間をおいてからもう一度アクセスして頂くか、管理者にお問い合わせください。</p>
        </v-card-text>

        <v-card-actions class="py-4">
          <v-spacer></v-spacer>
          <v-btn @click="dialogFatalError = false">閉じる</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';
import InputValueConversion from "../../../libs/InputValueConversion.js";

export default {
  name: "offer-info-login",
  data() {
    return {
      email: '',
      buyNumber: '',
      cdnUrl: VueConfig.cdn_url,
      dialogNoOffer: false,
      dialogFatalError: false,
      dialogExpiredOffer: false,
    }
  },
  created() {
    this.updateBuyFormItems({name: 'site_code', value: this.$siteCode});
    this.updateFormItems({name:'buyNumber', value: ''})
    this.updateFormItems({name:'email', value: ''})
  },
  computed: {
    ...mapGetters('buyState', [
      'getFormItems',
    ]),
    formItems() {
      return this.getFormItems;
    },
    isCharibon() {
      return this.$siteCode === VueConfig.siteCode.charibon;
    }
  },
  methods: {
    ...mapActions({
      updateFormItems: 'buyState/updateFormItems',
      updateBuyFormItems: 'buy/updateFormItems',
    }),

    buyDataAuth(){
      const _this = this;
      axios.post( '/api/spot/login' , {
        email: this.formItems.email,
        kaitori_num: this.formItems.buyNumber,
        site_code: this.$siteCode,
      }).then(response => {

        if(response.status != 200) {
          this.dialogFatalError = true;
          return;
        }

        if (!response.data.exists) {
          this.dialogNoOffer = true;
          return;
        }

        if (response.data.expired) {
          this.dialogExpiredOffer = true;
          return;
        }

        if (response.data.succeeded) {
          Object.values(response.data).every(function (type){
            if(type) _this.$router.push({name: "BuyStatus", query: _this.$route.query});
          });
        }

      }).catch(e => {
        this.dialogFatalError = true;
      });
    },
    spaceRemoval(value) {
      const v = value.replace(/\s+/g, '')
      return this.removalZeroWidthSpace(v);
    },
    removalZeroWidthSpace(value) {
      if(!value) return value;
      const s = value.replace(/[\u200B-\u200D\uFEFF]/g, '');  // removalZeroWidthSpace
      return InputValueConversion.fullWidthToHalfWidthAlphanum(s);
    },
  }
}
</script>

<style scoped lang="scss">
::v-deep {
  .v-input {
    input {
      background-color: transparent;
      border: 0 none;
    }
  }
  .v-radio {
    label {
      color: rgba(0, 0, 0, 0.87);
    }
  }
  .tooltip-link {
    color: #FFF;
    text-decoration: underline;
    font-weight: bold;
    pointer-events: initial;
  }
  .v-text-field--outlined {
    fieldset {
      border-width: 1px !important;
    }
    &.v-input--has-state {
      fieldset {
        border-color: #9c9b98 !important;
      }
    }
  }
  .input-bg-white {
    fieldset {
      background-color: #FFF !important;
    }
  }
}
</style>